<button
	#popoverTrigger="mtxPopoverTrigger"
	[mtxPopoverTriggerFor]="profilePopover"
	class="primary-text"
	mat-menu-item
	mtxPopoverTriggerOn="click"
>
	<span>Profile</span>
</button>

<mtx-popover
	#profilePopover="mtxPopover"
	(close)="profileOpenedFromDashboard = false"
	[closeOnPanelClick]="false"
	class="{{ profileOpenedFromDashboard ? 'profile-dashboard' : 'profile-margin-top' }} "
>
	<form *ngIf="IS_NOT_NULL_OR_UNDEFINED(profileForm)" [formGroup]="profileForm" class="m-t-1">
		<mat-card class="p-0 primary-border">
			<mat-card-content class="profile-dropdown font-size-14 padding-0-5 m-b-0">
				<div
					class="font-size-18 primary-text font-weight-bold"
					fxLayout="row"
					fxLayoutAlign="start center"
				>
					Profile
				</div>

				<div class="m-t-1" fxLayout="row" fxLayoutAlign="end center">
					<span (click)="openSetPasswordDialog()" class="link">Change Password</span>
				</div>

				<div fxLayout="row" fxLayoutGap="1rem">
					<div fxFlex>
						<mat-form-field class="full-width">
							<input
								autocomplete="off"
								formControlName="firstName"
								matInput
								placeholder="First Name"
							/>
						</mat-form-field>
					</div>

					<div fxFlex>
						<mat-form-field class="full-width">
							<input
								autocomplete="off"
								formControlName="lastName"
								matInput
								placeholder="Last Name"
							/>
						</mat-form-field>
					</div>
				</div>

				<div fxLayout="row" fxLayoutGap="1rem">
					<div fxFlex>
						<mat-form-field class="full-width" fxFlex>
							<input
								[showMaskTyped]="true"
								formControlName="mobileNumber"
								mask="(000) 000-0000"
								matInput
								placeholder="Mobile Number"
							/>
							<mat-icon class="primary-light-color" matSuffix>phone_iphone</mat-icon>
						</mat-form-field>
					</div>

					<div class="primary-text" fxFlex fxLayoutAlign="start center">
						Email: {{ user.email }}
					</div>
				</div>

				<div fxLayout="row" fxLayoutGap="1rem">
					<div fxFlex>
						<mat-form-field class="full-width" fxFlex>
							<input
								[showMaskTyped]="true"
								formControlName="phoneNumber"
								mask="(000) 000-0000"
								matInput
								placeholder="Phone Number"
							/>
							<mat-icon class="primary-light-color" matSuffix>contact_phone</mat-icon>
						</mat-form-field>
					</div>

					<div fxFlex>
						<mat-form-field class="full-width" fxFlex>
							<input
								autocomplete="off"
								formControlName="phoneNumberExt"
								matInput
								placeholder="Extension"
							/>
							<mat-icon class="primary-light-color" matSuffix>contact_phone</mat-icon>
						</mat-form-field>
					</div>
				</div>
				<div fxLayout="row" fxLayoutGap="1rem">
					<mat-form-field
						[ngClass]="{ 'highlight-border': highlightLandingPageSection }"
						class="m-t-0-4"
						fxFlex
					>
						<mat-select formControlName="landingPage" placeholder="Home Page">
							<ng-container *ngFor="let page of landingPages">
								<mat-option [value]="page.value">
									{{ page.label }}
								</mat-option>
							</ng-container>
						</mat-select>
					</mat-form-field>
					<div fxFlex>
						<mat-form-field class="full-width m-t-0-4" *ngIf="integrationService.isCarrierVettingIntegrationEnabled()">
							<input
								autocomplete="off"
								formControlName="onboardingLink"
								matInput
								placeholder="Onboarding Link"
							/>
						</mat-form-field>
					</div>
				</div>
				<div>
					<app-capacity-search-settings
						(onCapacitySearchSettingsChange)="onCapacitySearchSettingsChange($event)"
						[defaultSettings]="defaultCapacitySearchSettings"
					></app-capacity-search-settings>
				</div>

				<div *ngIf="carrierVettingService.isMCPEnabled()" fxLayout="row">
					<mat-form-field fxFlex="50">
						<input formControlName="mcpUsername" matInput placeholder="MyCarrierPortal username" />
					</mat-form-field>
				</div>

				<div
					class="full-width"
					*ngIf="IS_NOT_NULL_OR_UNDEFINED(userSettings?.HIDE_ENGAGE_CARRIER_DIALOG)"
				>
					<span class="link font-size-13" (click)="updateHideEngageCarrierDialogSetting()">
						Reset Engaged Carrier Do Not Ask
					</span>
				</div>
			</mat-card-content>

			<mat-dialog-actions>
				<div class="padding-0-5 full-width" fxLayoutAlign="end center" fxLayoutGap="2rem">
					<span (click)="closeProfilePopover()" class="link">Close</span>
					<button
						(click)="updateProfile()"
						*ngIf="!isProfileRequestInProgress"
						[disabled]="!profileForm.valid"
						class="focused-button"
						color="primary"
						mat-raised-button
					>
						Update
					</button>
					<mat-spinner *ngIf="isProfileRequestInProgress" [diameter]="30"></mat-spinner>
				</div>
			</mat-dialog-actions>
		</mat-card>
	</form>
</mtx-popover>
